/* Today's date as YYYY-MM-DD in the user's own timezone.
 *
 * `new Date().toISOString().slice(0,10)` returns the date in UTC. Houston is
 * UTC-5/-6, so from 7pm onwards it returns TOMORROW - which is how the Daily
 * Cash sheet, and every report date box, opened on the wrong day for anyone
 * working an evening shift.
 *
 * The browser already sits in the yard's timezone, so reading the local date
 * parts is both correct and free of any configuration. */
export function todayISO(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/* Any Date -> YYYY-MM-DD in the viewer's timezone. */
export const toISODate = (value) => {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? "" : todayISO(d);
};
